import { render, staticRenderFns } from "./EquationRule.vue?vue&type=template&id=00a31c3c&"
import script from "./EquationRule.vue?vue&type=script&lang=js&"
export * from "./EquationRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports